<template>
  <div v-show="show" ref="ctx" class="v-context" :style="style" @contextmenu.prevent @click="close">
    <ul>
      <slot :data="userData"></slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'vue-context',
  data() {
    return {
      show: false,
      top: 0,
      left: 0,
      userData: {},
      _onBody: null,
      _onKey: null,
    }
  },
  computed: {
    style() {
      return {
        top: this.top + 'px',
        left: this.left + 'px',
      }
    }
  },
  created() {
    // Bind once so we can reliably remove listeners
    this._onBody = (e) => {
      if (this.show && this.$refs.ctx && !this.$refs.ctx.contains(e.target)) {
        this.close()
      }
    }
    this._onKey = (e) => {
      if (e.key === 'Escape') this.close()
    }
  },
  methods: {
    open(event, data) {
      this.userData = data || {}
      this.show = true

      this.$nextTick(() => {
        const el = this.$refs.ctx
        if (!el) return

        // Use clientX/clientY directly — position:fixed is relative to viewport
        let top = event.clientY
        let left = event.clientX

        const rect = el.getBoundingClientRect()
        const winW = window.innerWidth
        const winH = window.innerHeight

        if (left + rect.width > winW) {
          left = winW - rect.width - 5
        }
        if (top + rect.height > winH) {
          top = top - rect.height
        }

        this.top = top
        this.left = left
      })

      // Use capture phase so we always hear clicks even if stopped
      document.addEventListener('mousedown', this._onBody, true)
      document.addEventListener('contextmenu', this._onBody, true)
      document.addEventListener('keydown', this._onKey)
    },
    close() {
      this.show = false
      document.removeEventListener('mousedown', this._onBody, true)
      document.removeEventListener('contextmenu', this._onBody, true)
      document.removeEventListener('keydown', this._onKey)
    },
  },
  unmounted() {
    this.close()
  }
}
</script>

<style>
.v-context {
  position: fixed;
  z-index: 99999;
  background: var(--bg-color, #1a1a2e);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.4);
  min-width: 180px;
  padding: 0;
}
.v-context ul {
  list-style: none;
  margin: 0;
  padding: 4px 0;
}
.v-context li {
  margin: 0;
  padding: 0;
}
.v-context li a {
  display: block;
  padding: 6px 16px;
  color: var(--color, #ccc);
  text-decoration: none;
  font-size: 13px;
  white-space: nowrap;
  cursor: pointer;
}
.v-context li a:hover {
  background: rgba(255,255,255,0.1);
  color: #fff;
}
</style>
